module.exports = __webpack_public_path__ + "img/2.bc3a6d94.png";